import React, { useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import MaintenanceSettings from "../../components/maintenance/MaintenanceSettings";
import { STARTING_PAGE } from "../../constants/constants";
import {
  fetchMachineTypes,
  fetchMachineTypesSuccess,
  fetchMachineTypesFailure,
  createMachineType,
  createMachineTypeSuccess,
  createMachineTypeFailure,
  updateMachineType,
  updateMachineTypeSuccess,
  updateMachineTypeFailure,
  deleteMachineType,
  deleteMachineTypeSuccess,
  deleteMachineTypeFailure,
  fetchFacilityTypes,
  fetchFacilityTypesSuccess,
  fetchFacilityTypesFailure,
  createFacilityType,
  createFacilityTypeSuccess,
  createFacilityTypeFailure,
  updateFacilityType,
  updateFacilityTypeSuccess,
  updateFacilityTypeFailure,
  deleteFacilityType,
  deleteFacilityTypeSuccess,
  deleteFacilityTypeFailure,
  fetchMaintenanceLocations,
  fetchMaintenanceLocationsSuccess,
  fetchMaintenanceLocationsFailure,
  createMaintenanceLocation,
  createMaintenanceLocationSuccess,
  createMaintenanceLocationFailure,
  updateMaintenanceLocation,
  updateMaintenanceLocationSuccess,
  updateMaintenanceLocationFailure,
  deleteMaintenanceLocation,
  deleteMaintenanceLocationSuccess,
  deleteMaintenanceLocationFailure,
  fetchServiceProviders,
  fetchServiceProvidersSuccess,
  fetchServiceProvidersFailure,
  createServiceProvider,
  createServiceProviderSuccess,
  createServiceProviderFailure,
  updateServiceProvider,
  updateServiceProviderSuccess,
  updateServiceProviderFailure,
  deleteServiceProvider,
  deleteServiceProviderSuccess,
  deleteServiceProviderFailure,
} from "../../store/maintenance/actions";

const MaintenanceSettingsContainer = ({
  machineTypes,
  facilityTypes,
  locations,
  serviceProviders,
  fetchMachineTypes,
  createMachineType,
  updateMachineType,
  deleteMachineType,
  fetchFacilityTypes,
  createFacilityType,
  updateFacilityType,
  deleteFacilityType,
  fetchMaintenanceLocations,
  createMaintenanceLocation,
  updateMaintenanceLocation,
  deleteMaintenanceLocation,
  fetchServiceProviders,
  createServiceProvider,
  updateServiceProvider,
  deleteServiceProvider,
}) => {
  const [machineTypesPage, setMachineTypesPage] = useState(STARTING_PAGE);
  const [machineTypesFilters, setMachineTypesFilters] = useState({
    isActive: null,
    search: null,
  });
  const [facilityTypesPage, setFacilityTypesPage] = useState(STARTING_PAGE);
  const [facilityTypesFilters, setFacilityTypesFilters] = useState({
    isActive: null,
    search: null,
  });
  const [locationsPage, setLocationsPage] = useState(STARTING_PAGE);
  const [locationsFilters, setLocationsFilters] = useState({
    isActive: null,
    search: null,
  });
  const [serviceProvidersPage, setServiceProvidersPage] = useState(STARTING_PAGE);
  const [serviceProvidersFilters, setServiceProvidersFilters] = useState({
    isActive: null,
    search: null,
  });
  const [activeSettingsTab, setActiveSettingsTab] = useState("machineTypes");

  useEffect(() => {
    fetchMachineTypes(STARTING_PAGE);
    fetchFacilityTypes(STARTING_PAGE);
    fetchMaintenanceLocations(STARTING_PAGE);
    fetchServiceProviders(STARTING_PAGE);
  }, [fetchMachineTypes, fetchFacilityTypes, fetchMaintenanceLocations, fetchServiceProviders]);

  // Machine Type handlers
  const handleMachineTypesPageChange = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== machineTypesPage) {
        setMachineTypesPage(page);
        fetchMachineTypes(
          page,
          machineTypesFilters.isActive,
          machineTypesFilters.search
        );
      }
    },
    [machineTypesPage, machineTypesFilters, fetchMachineTypes]
  );

  const handleMachineTypesFilter = useCallback(
    (newFilters) => {
      setMachineTypesFilters(newFilters);
      setMachineTypesPage(STARTING_PAGE);
      fetchMachineTypes(
        STARTING_PAGE,
        newFilters.isActive,
        newFilters.search
      );
    },
    [fetchMachineTypes]
  );

  const handleCreateMachineType = useCallback(
    (data) => {
      createMachineType(data);
    },
    [createMachineType]
  );

  const handleUpdateMachineType = useCallback(
    (id, data) => {
      updateMachineType(id, data);
    },
    [updateMachineType]
  );

  const handleDeleteMachineType = useCallback(
    (id) => {
      deleteMachineType(id);
    },
    [deleteMachineType]
  );

  // Facility Type handlers
  const handleFacilityTypesPageChange = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== facilityTypesPage) {
        setFacilityTypesPage(page);
        fetchFacilityTypes(
          page,
          facilityTypesFilters.isActive,
          facilityTypesFilters.search
        );
      }
    },
    [facilityTypesPage, facilityTypesFilters, fetchFacilityTypes]
  );

  const handleFacilityTypesFilter = useCallback(
    (newFilters) => {
      setFacilityTypesFilters(newFilters);
      setFacilityTypesPage(STARTING_PAGE);
      fetchFacilityTypes(
        STARTING_PAGE,
        newFilters.isActive,
        newFilters.search
      );
    },
    [fetchFacilityTypes]
  );

  const handleCreateFacilityType = useCallback(
    (data) => {
      createFacilityType(data);
    },
    [createFacilityType]
  );

  const handleUpdateFacilityType = useCallback(
    (id, data) => {
      updateFacilityType(id, data);
    },
    [updateFacilityType]
  );

  const handleDeleteFacilityType = useCallback(
    (id) => {
      deleteFacilityType(id);
    },
    [deleteFacilityType]
  );

  // Location handlers
  const handleLocationsPageChange = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== locationsPage) {
        setLocationsPage(page);
        fetchMaintenanceLocations(
          page,
          locationsFilters.isActive,
          locationsFilters.search
        );
      }
    },
    [locationsPage, locationsFilters, fetchMaintenanceLocations]
  );

  const handleLocationsFilter = useCallback(
    (newFilters) => {
      setLocationsFilters(newFilters);
      setLocationsPage(STARTING_PAGE);
      fetchMaintenanceLocations(
        STARTING_PAGE,
        newFilters.isActive,
        newFilters.search
      );
    },
    [fetchMaintenanceLocations]
  );

  const handleCreateLocation = useCallback(
    (data) => {
      createMaintenanceLocation(data);
    },
    [createMaintenanceLocation]
  );

  const handleUpdateLocation = useCallback(
    (id, data) => {
      updateMaintenanceLocation(id, data);
    },
    [updateMaintenanceLocation]
  );

  const handleDeleteLocation = useCallback(
    (id) => {
      deleteMaintenanceLocation(id);
    },
    [deleteMaintenanceLocation]
  );

  // Service Provider handlers
  const handleServiceProvidersPageChange = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== serviceProvidersPage) {
        setServiceProvidersPage(page);
        fetchServiceProviders(
          page,
          serviceProvidersFilters.isActive,
          serviceProvidersFilters.search
        );
      }
    },
    [serviceProvidersPage, serviceProvidersFilters, fetchServiceProviders]
  );

  const handleServiceProvidersFilter = useCallback(
    (newFilters) => {
      setServiceProvidersFilters(newFilters);
      setServiceProvidersPage(STARTING_PAGE);
      fetchServiceProviders(
        STARTING_PAGE,
        newFilters.isActive,
        newFilters.search
      );
    },
    [fetchServiceProviders]
  );

  const handleCreateServiceProvider = useCallback(
    (data) => {
      createServiceProvider(data);
    },
    [createServiceProvider]
  );

  const handleUpdateServiceProvider = useCallback(
    (id, data) => {
      updateServiceProvider(id, data);
    },
    [updateServiceProvider]
  );

  const handleDeleteServiceProvider = useCallback(
    (id) => {
      deleteServiceProvider(id);
    },
    [deleteServiceProvider]
  );

  const loading = machineTypes.loading || facilityTypes.loading || locations.loading || serviceProviders.loading;
  const error = machineTypes.error || facilityTypes.error || locations.error || serviceProviders.error;

  return (
    <>
      <MaintenanceSettings
        machineTypes={machineTypes.list}
        machineTypesPages={machineTypes.pages}
        machineTypesLoading={machineTypes.loading}
        facilityTypes={facilityTypes.list}
        facilityTypesPages={facilityTypes.pages}
        facilityTypesLoading={facilityTypes.loading}
        onFilterFacilityTypes={handleFacilityTypesFilter}
        activeTab={activeSettingsTab}
        onTabChange={setActiveSettingsTab}
        locations={locations.list}
        locationsPages={locations.pages}
        locationsLoading={locations.loading}
        serviceProviders={serviceProviders.list}
        serviceProvidersPages={serviceProviders.pages}
        serviceProvidersLoading={serviceProviders.loading}
        loading={loading}
        error={error}
        onCreateMachineType={handleCreateMachineType}
        onUpdateMachineType={handleUpdateMachineType}
        onDeleteMachineType={handleDeleteMachineType}
        onFilterMachineTypes={handleMachineTypesFilter}
        onCreateFacilityType={handleCreateFacilityType}
        onUpdateFacilityType={handleUpdateFacilityType}
        onDeleteFacilityType={handleDeleteFacilityType}
        onCreateLocation={handleCreateLocation}
        onUpdateLocation={handleUpdateLocation}
        onDeleteLocation={handleDeleteLocation}
        onFilterLocations={handleLocationsFilter}
        onCreateServiceProvider={handleCreateServiceProvider}
        onUpdateServiceProvider={handleUpdateServiceProvider}
        onDeleteServiceProvider={handleDeleteServiceProvider}
        onFilterServiceProviders={handleServiceProvidersFilter}
      />
      {activeSettingsTab === "machineTypes" && machineTypes.pages > 1 && (
        <ReactPaginate
          pageCount={machineTypes.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handleMachineTypesPageChange}
          initialPage={machineTypesPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={machineTypesPage - 1}
        />
      )}
      {activeSettingsTab === "facilityTypes" && facilityTypes.pages > 1 && (
        <ReactPaginate
          pageCount={facilityTypes.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handleFacilityTypesPageChange}
          initialPage={facilityTypesPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={facilityTypesPage - 1}
        />
      )}
      {activeSettingsTab === "locations" && locations.pages > 1 && (
        <ReactPaginate
          pageCount={locations.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handleLocationsPageChange}
          initialPage={locationsPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={locationsPage - 1}
        />
      )}
      {activeSettingsTab === "serviceProviders" && serviceProviders.pages > 1 && (
        <ReactPaginate
          pageCount={serviceProviders.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handleServiceProvidersPageChange}
          initialPage={serviceProvidersPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={serviceProvidersPage - 1}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  machineTypes: state.maintenance.machineTypes,
  facilityTypes: state.maintenance.facilityTypes,
  locations: state.maintenance.locations,
  serviceProviders: state.maintenance.serviceProviders,
});

const mapDispatchToProps = (dispatch) => ({
  // Machine Types
  fetchMachineTypes: (page, isActive, search) => {
    dispatch(fetchMachineTypes(page, isActive, search)).payload.then(
      (response) => {
        dispatch(fetchMachineTypesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMachineTypesFailure(error.response?.data || error));
      }
    );
  },
  createMachineType: (data) => {
    dispatch(createMachineType(data)).payload.then(
      (response) => {
        dispatch(createMachineTypeSuccess(response.data));
      },
      (error) => {
        dispatch(createMachineTypeFailure(error.response?.data || error));
      }
    );
  },
  updateMachineType: (id, data) => {
    dispatch(updateMachineType(id, data)).payload.then(
      (response) => {
        dispatch(updateMachineTypeSuccess(response.data));
      },
      (error) => {
        dispatch(updateMachineTypeFailure(error.response?.data || error));
      }
    );
  },
  deleteMachineType: (id) => {
    dispatch(deleteMachineType(id)).payload.then(
      () => {
        dispatch(deleteMachineTypeSuccess(id));
      },
      (error) => {
        dispatch(deleteMachineTypeFailure(error.response?.data || error));
      }
    );
  },
  // Facility Types
  fetchFacilityTypes: (page, isActive, search) => {
    dispatch(fetchFacilityTypes(page, isActive, search)).payload.then(
      (response) => {
        dispatch(fetchFacilityTypesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchFacilityTypesFailure(error.response?.data || error));
      }
    );
  },
  createFacilityType: (data) => {
    dispatch(createFacilityType(data)).payload.then(
      (response) => {
        dispatch(createFacilityTypeSuccess(response.data));
      },
      (error) => {
        dispatch(createFacilityTypeFailure(error.response?.data || error));
      }
    );
  },
  updateFacilityType: (id, data) => {
    dispatch(updateFacilityType(id, data)).payload.then(
      (response) => {
        dispatch(updateFacilityTypeSuccess(response.data));
      },
      (error) => {
        dispatch(updateFacilityTypeFailure(error.response?.data || error));
      }
    );
  },
  deleteFacilityType: (id) => {
    dispatch(deleteFacilityType(id)).payload.then(
      () => {
        dispatch(deleteFacilityTypeSuccess(id));
      },
      (error) => {
        dispatch(deleteFacilityTypeFailure(error.response?.data || error));
      }
    );
  },
  // Locations
  fetchMaintenanceLocations: (page, isActive, search) => {
    dispatch(fetchMaintenanceLocations(page, isActive, search)).payload.then(
      (response) => {
        dispatch(fetchMaintenanceLocationsSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMaintenanceLocationsFailure(error.response?.data || error));
      }
    );
  },
  createMaintenanceLocation: (data) => {
    dispatch(createMaintenanceLocation(data)).payload.then(
      (response) => {
        dispatch(createMaintenanceLocationSuccess(response.data));
      },
      (error) => {
        dispatch(createMaintenanceLocationFailure(error.response?.data || error));
      }
    );
  },
  updateMaintenanceLocation: (id, data) => {
    dispatch(updateMaintenanceLocation(id, data)).payload.then(
      (response) => {
        dispatch(updateMaintenanceLocationSuccess(response.data));
      },
      (error) => {
        dispatch(updateMaintenanceLocationFailure(error.response?.data || error));
      }
    );
  },
  deleteMaintenanceLocation: (id) => {
    dispatch(deleteMaintenanceLocation(id)).payload.then(
      () => {
        dispatch(deleteMaintenanceLocationSuccess(id));
      },
      (error) => {
        dispatch(deleteMaintenanceLocationFailure(error.response?.data || error));
      }
    );
  },
  // Service Providers
  fetchServiceProviders: (page, isActive, search) => {
    dispatch(fetchServiceProviders(page, isActive, search)).payload.then(
      (response) => {
        dispatch(fetchServiceProvidersSuccess(response.data));
      },
      (error) => {
        dispatch(fetchServiceProvidersFailure(error.response?.data || error));
      }
    );
  },
  createServiceProvider: (data) => {
    dispatch(createServiceProvider(data)).payload.then(
      (response) => {
        dispatch(createServiceProviderSuccess(response.data));
      },
      (error) => {
        dispatch(createServiceProviderFailure(error.response?.data || error));
      }
    );
  },
  updateServiceProvider: (id, data) => {
    dispatch(updateServiceProvider(id, data)).payload.then(
      (response) => {
        dispatch(updateServiceProviderSuccess(response.data));
      },
      (error) => {
        dispatch(updateServiceProviderFailure(error.response?.data || error));
      }
    );
  },
  deleteServiceProvider: (id) => {
    dispatch(deleteServiceProvider(id)).payload.then(
      () => {
        dispatch(deleteServiceProviderSuccess(id));
      },
      (error) => {
        dispatch(deleteServiceProviderFailure(error.response?.data || error));
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceSettingsContainer);
